// src/styles/colors.js
export const colors = {
    // Cores oficiais do MVI da Nogle
    primary: '#021E00',         // Verde escuro
    secondary: '#02EA75',       // Verde neon
    background: '#0C0C0C',      // Fundo geral escuro refinado
    surface: '#1A1A1A',         // Cartões e containers

    // Tons neutros e de contraste
    white: '#FFFFFF',
    beige: '#F2EDDA',
    gray: {
        100: '#E2E8F0',
        200: '#CBD5E0',
        300: '#A0AEC0',
        400: '#718096',
        500: '#4A5568',
        600: '#2D3748',
        700: '#1A202C',
        800: '#171923',
        900: '#0F0F0F',
    },

    red: '#E53E3E',
    green: '#02BD6D',
    blue: '#3182CE',
    yellow: '#ECC94B',

    transparent: 'transparent',
    current: 'currentColor',
};
